import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import MainNav from "../components/main-nav/MainNav";
import { useDispatch } from "react-redux";
import Toasts from "../components/toasts/Toasts";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AuthAction from "../stores/Auth/AuthAction";
import HttpErrorResponseModel from "../models/HttpErrorResponseModel";
//CUSTOM THEME CREATION
export const theme = createTheme({
  overrides: {
    MuiSelect: {
      select: {
        "&:focus": {
          border: "1px solid #2a5e6c",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#2a5e6c",
      contrastText: "#e5e2e2",
      dark: "#000000",
    },
    secondary: {
      main: "#e93017",
    },
    comman: {
      black: "#2a5e6c",
    },
    info: {
      main: "#4e5c5e",
    },

    text: {
      primary: "#2a5e6c",

      secondary: "#2a5e6c",
    },
    divider: "#2a5e6c",

    borderColor: {
      textField: "#a0bfc9",
    },

    background: {
      primary: "#d3e2e6",
      default: "#f3f9fb",
      paper: "#fff",
      button: "#d6ebf0",
      comman: "#797676",
    },

    // Datagrid
    datagrid: {
      background: {
        datagridCell: "#ffffff",
        datagridHeader: "#d3e2e6",
        hover: "#eeeeee",
      },
      Columns: {
        fontSize: 17,
      },
    },

    // post button
    // addButton: {
    //   height: "40px",
    //   width: "30px",
    //   borderRadius: "55%",
    // },

    addButton: {
      height: "40px",
      width: "40px",
      borderRadius: "55%",
    },

    //Button Component

    buttonComponent: {
      background: {
        primary: "#57828e",
        success: "#35C37D",
        error: "#ff4444",
      },
      hover: {
        primary: "#0b2e36",
        success: "#035029",
        error: "#CC0000",
      },
      color: "#d6ebf0",
      border: "solid 1px #eaeaea",
      borderRadius: {
        small: "5px",
        medium: "10px",
        large: "12px",
      },
      fontSize: {
        small: "10px",
        medium: "12px",
        large: "14px",
        extraLarge: "16px",
      },
      paddingX: {
        small: "10px",
        medium: "20px",
        large: "30px",
      },
      width: {
        small: "100px",
        medium: "150px",
        large: "200px",
      },
      // borderRadius: {
      //   small: "8px",
      //   medium: "16px",
      // },
    },
    dashboard: {
      red: "#f79f8a",
      yellow: "#ffe203",
      green: "#29c060",
      lightGreen: "#06f234",
      timeText: "#bfbfbf",
      lightTeal: "#a0bfc9",
      icons: "#899da2",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 0,
      tablet: 640,
      laptop: 1024,
      desktop: 1200,
    },
  },

  typography: {
    fontFamily: "BookAntiqua",
    fontWeightRegular: "normal",
    fontSize: "14px",
    fontWeightBold: "bold",
    fontStyle: "normal",
    fontStretch: "normal",
    h2: {
      fontSize: "28px",
      fontFamily: "BookAntiqua",
    },
    button: {
      fontWeight: 500,
      fontSize: "0.875rem",
      textTransform: "uppercase",
      border: "solid 1px #eaeaea",
      borderRadius: "3px",
      color: "#d6ebf0",
    },
    subtitle1: {
      fontFamily: "BookAntiqua",
      fontSize: "18px",
    },
    padding: 0,
  },
  shadows: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
  shape: { borderRadius: 3 },
  border: "1px solid #f2f2f2",
  borderRadius: "8px",
  zIndex:{
  //Default from MUI
    drawer: 1200,
    modal: 1300,
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          ":-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px white inset",
            backgroundColor: "red !important",
          },
        },
      },
    },

    // Name of the component
    MuiDataGrid: {
      defaultProps: {
        // The props to change the default for.
        disableRipple: true, // No more ripple, on the whole application 💣!
      },
      cell: {
        background: "red !important",
        content: "hello!",
        padding: 0,
      },
    },

    //Mui Form control style overrides

    MuiFormControl: {
      styleOverrides: {
        fullWidth: true,
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        root: {
          ".MuiOutlinedInput-root": {
            outline: "none",
            backgroundColor: "#fff",
            fontSize: "14px",
            borderRadius: "5px",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "1px solid #2a5e6c",
              outline: "none",
            },
          },
          ".MuiAutocomplete-tagSizeMedium": {
            height: "fit-content",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          outline: "solid 1px #a0bfc9",
          backgroundColor: "#fff",
          fontSize: "14px",
          borderRadius: "5px",
          // ".MuiSelect-select":{
          //   border:"1.5px solid 2a5e6c"
          // }
        },
      },
    },
  },
});

export default function App() {
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const init = async () => {
    await dispatch(AuthAction.InitLogin()).then((model) => {
      const isError = model instanceof HttpErrorResponseModel;
    });
  };

  useEffect(() => {
    init();
  }, [init]);

  return (
    <div className="app">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <MainNav />
          <Toasts />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}
